const STORAGE_KEY = "supergerman_app_state_v2"

export type PersistedState = {
  currentKrokId: string | null
  gaps: Record<number, Record<number, string>>
  revealed: Record<number, boolean>
  scrollY: number
}

export function saveState(state: PersistedState): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(state)
    )
  } catch {
    // ignore storage errors (quota / private mode)
  }
}

export function loadState(): PersistedState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null

    return JSON.parse(raw) as PersistedState
  } catch {
    return null
  }
}

export function clearState(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
